import React, { useState, useEffect } from "react";
import { Breadcrumb, Button, Input, Table, Image, notification } from "antd";
import { callApi } from "../../api/apiCaller";
import routes from "../../api/routes";
import Loader from "../../components/loader/loader";
import { EditOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { GreenNotify, RedNotify } from "../../helper/helper";
import Video from "../../components/videoUpdate/videoUpdate";
import UpdateVideo from "../../components/videoUpdate1/videoUpdate1";
import { homeIcon } from "../../assets";

const Organizers = () => {
  const [yogaVideos, setYogaVideos] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedYoga, setSelectedYoga] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false); // New state for edit mode
  const [updateRecordData, setUpdateRecordData] = useState(null);

  const getAllVideos = () => {
    callApi("GET", routes.getVideos, null, setIsLoading, (res) => {
      setYogaVideos(res?.data?.videos || []);
    });
  };

  useEffect(() => {
    getAllVideos();
  }, []);

  const handleDelete = (recordId) => {
    callApi(
      "DELETE",
      `${routes.deleteVideo}/${recordId}`,
      null,
      setIsLoading,
      (res) => {
        if (res.status === 200) {
          setYogaVideos((prevVideos) =>
            prevVideos.filter((video) => video._id !== recordId)
          );
          GreenNotify("Video Deleted Successfully");
        } else {
          RedNotify("Error Occurred while deleting video");
        }
      },
      (error) => {
        notification.error({
          message: "Error",
          description: "An error occurred while deleting the video.",
        });
      }
    );
  };

  const handleAddYoga = () => {
    setIsEditMode(false); // Set to add mode
    setUpdateRecordData(null); // Clear selected video
    setIsModalVisible(true);
  };

  const handleEditYoga = (recordId) => {
    const selectedVideo = yogaVideos.find((video) => video._id === recordId);
    setUpdateRecordData(selectedVideo); // Set selected video data
    setIsEditMode(true); // Set to edit mode
    setIsModalVisible(true); // Open modal
  };

  const columns = [
    {
      title: "FaceYoga",
      dataIndex: "yogaTitle",
      align: "center",
    },
    {
      title: "Video Title",
      dataIndex: "title",
      align: "center",
    },
    {
      title: "Description",
      dataIndex: "description",
      align: "center",
      render: (text, record) => <span>{text?.slice(0, 50)}...</span>,
    },
    {
      title: "Url",
      dataIndex: "url",
      align: "center",
      render: (text, record) => <span>{text?.slice(0, 50)}...</span>,
    },
    {
      title: "Thumbnail",
      dataIndex: "thumbnail",
      align: "center",
      render: (thumbnail) => (
        <Image
          style={{
            width: 100,
            height: 100,
            borderRadius: 50,
            objectFit: "cover",
          }}
          src={thumbnail}
          alt="yoga-image"
        />
      ),
    },
    {
      title: "Action",
      dataIndex: "_id",
      align: "center",
      render: (text, record) => (
        <div style={{ whiteSpace: "nowrap" }}>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => handleEditYoga(record._id)}
            style={{ marginRight: 8 }}
          ></Button>
          <Button
            type="danger"
            icon={<DeleteOutlined />}
            onClick={() => handleDelete(record._id)}
            style={{ marginRight: 8 }}
          ></Button>
        </div>
      ),
    },
  ];

  const data = yogaVideos
    .map((item, index) => ({
      key: index,
      _id: item?._id,
      yogaTitle: item?.yogaTitle,
      title: item?.title,
      description: item?.content,
      url: item?.url || item?.status || "N/A",
      thumbnail: item?.thumbnail,
    }))
    .filter((item) => {
      const videoTitleMatch = item?.title
        ?.toLowerCase()
        .includes(searchText?.toLowerCase());
      const yogaTitleMatch = item?.yogaTitle
        ?.toLowerCase()
        .includes(searchText?.toLowerCase());
      return videoTitleMatch || yogaTitleMatch;
    });

  const getRowClassName = (record, index) =>
    index % 2 === 0 ? "server-role-even-row" : "server-role-odd-row";

  return (
    <div className="admin-products-main-container">
      <Loader loading={isLoading} />
      <Breadcrumb separator=">" className="bread-crumb">
        <div className="configure-server-home-icon">
          <img src={homeIcon} alt="home-icon" />
        </div>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>Videos</Breadcrumb.Item>
      </Breadcrumb>
      <div className="configure-server-roles-main-heading-container">
        <h1>Videos</h1>
        <div className="search-inputs" style={{ width: "30rem" }}>
          <Input
            placeholder="Search..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
      </div>
      <Button
        type="primary"
        icon={<PlusOutlined />}
        onClick={handleAddYoga}
        style={{ marginBottom: "16px" }}
      >
        Add Video
      </Button>
      <div className="server-roles-tb-main-container">
        <Table
          rowClassName={getRowClassName}
          columns={columns}
          dataSource={data}
          pagination={true}
        />
      </div>

      {/* Render the appropriate component based on edit mode */}
      {isModalVisible &&
        (isEditMode ? (
          <UpdateVideo
            visible={isModalVisible}
            toggleModal={() => {
              setIsModalVisible(false);
              getAllVideos();
            }}
            recordData={updateRecordData}
          />
        ) : (
          <Video
            visible={isModalVisible}
            toggleModal={() => {
              setIsModalVisible(false);
              getAllVideos();
            }}
            recordData={updateRecordData}
          />
        ))}
    </div>
  );
};

export default Organizers;
